"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ContactMessageCenter = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_ContactMessageCenter_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 16,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 7.5a2.495 2.495 0 0 0-2.252-2.475C13.008 2.989 10.713 1.5 8 1.5 5.294 1.5 3 2.982 2.255 5.012A2.504 2.504 0 0 0 0 7.5C0 8.879 1.122 10 2.5 10a.5.5 0 0 0 .5-.5V6.435C3 4.265 5.245 2.5 8 2.5c2.757 0 5 1.765 5 3.935V9.5c0 1.592-1.382 2.924-3.256 3.347A.986.986 0 0 0 9 12.5H8a1 1 0 1 0 0 2h1a.993.993 0 0 0 .932-.66c2.168-.48 3.81-2.013 4.04-3.888A2.502 2.502 0 0 0 16 7.5ZM2 6.435v2.479a1.502 1.502 0 0 1 .016-2.834 4.11 4.11 0 0 0-.015.355Zm12 2.473V6.435c0-.118-.011-.234-.021-.35.592.201 1.022.756 1.022 1.415 0 .65-.42 1.2-1 1.408ZM9 4.5H7a3 3 0 0 0-3 3c0 .885.39 1.672 1 2.221V11.5a.5.5 0 0 0 .854.354L7.206 10.5H9a3 3 0 1 0 0-6Zm0 5H7.206a1 1 0 0 0-.707.293L6 10.292v-.57a1 1 0 0 0-.33-.743A1.973 1.973 0 0 1 5 7.5c0-1.103.898-2 2-2h2c1.103 0 2 .897 2 2s-.897 2-2 2Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_ContactMessageCenter_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = ContactMessageCenter;
exports["default"] = _default;